/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M11.2 12.8V3.2h-.8c-.2352 0-.4687.0078-.7.0232C4.2827 3.5832 0 8.0915 0 13.6 0 19.3438 4.6562 24 10.4 24c5.5085 0 10.0168-4.2826 10.3768-9.7.0154-.2313.0232-.4648.0232-.7v-.8h-9.6Zm-1.6 1.6V4.8368l-.2509.0253A8.76 8.76 0 0 0 8.1 5.1036C4.3553 6.1148 1.6 9.5356 1.6 13.6c0 4.8601 3.9399 8.8 8.8 8.8 4.0644 0 7.4852-2.7553 8.4964-6.5a8.7532 8.7532 0 0 0 .2415-1.2491l.0237-.2509H9.6ZM14.3.0232C19.486.3678 23.6322 4.514 23.9768 9.7c.0154.2314.0232.4648.0232.7v.8H12.8V0h.8c.2352 0 .4687.0078.7.0232ZM22.3616 9.6l-.0237-.2509A8.7544 8.7544 0 0 0 22.0964 8.1c-.8133-3.0115-3.1849-5.3831-6.1964-6.1964a8.7588 8.7588 0 0 0-1.2491-.2415L14.4 1.6368V9.6h7.9616Z"
    clipRule="evenodd"
  />,
  'Analytics'
);
